import { render, staticRenderFns } from "./AdminInfo.vue?vue&type=template&id=959e17ba&scoped=true&"
import script from "./AdminInfo.vue?vue&type=script&lang=js&"
export * from "./AdminInfo.vue?vue&type=script&lang=js&"
import style0 from "./AdminInfo.vue?vue&type=style&index=0&id=959e17ba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959e17ba",
  null
  
)

export default component.exports